import { Typography } from "antd";
import styled from "styled-components";

interface TitleProps {
  readonly dark?: boolean;
}

interface ExpertTextProps {
  readonly dark?: boolean;
  readonly small?: boolean;
}
interface MediumHeaderTitleProps {
  readonly dark?: boolean;
  readonly fontSize?: boolean;
}
export const HeaderTitle = styled(Typography.Title)<TitleProps>`
  &.ant-typography {
    color: ${(props) => (props.dark ? "#3D3D3D" : "#FFF")};
    font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 3.75rem;
    line-height: 3.75rem;
    font-weight: 400;
    margin-bottom: 1rem;

    @media screen and (max-width: 760px) {
      font-size: 2rem;
    }
  }
`;
export const MediumHeaderTitle = styled(
  Typography.Title
)<MediumHeaderTitleProps>`
  &.ant-typography {
    font-family: "Rogan";
    color: ${(props) => (props.dark ? "#75706b" : "#FFF")};
    font-size: ${(props) => (props.fontSize ? "2rem" : "2.5rem")};
    line-height: 38px;
    font-weight: 300;
    margin-bottom: 20px;
    @media screen and (max-width: 1024px) {
      font-size: 2rem;
    }
    @media screen and (max-width: 760px) {
      font-size: 1.2rem;
    }
  }
`;
export const HeaderSubTitle = styled(Typography.Title)<TitleProps>`
  &.ant-typography {
    font-family: "Planer", -apple-system, BlinkMacSystemFont, sans-serif;
    color: ${(props) => (props.dark ? "#75706b" : "#FFF")};
    font-size: 16px;
    line-height: 16px;
    font-weight: 400;
    margin: 0px 0px !important;
  }
`;

export const ExpertText = styled(Typography.Paragraph)<ExpertTextProps>`
  &.ant-typography {
    color: ${(props) => (props.dark ? "#75706B" : "#FFF")};
    font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: ${(props) => (props.small ? "14px" : "16px")};
    line-height: 24px;
  }
`;

interface SmallProps {
  readonly size?: boolean;
  readonly line?: boolean;
  readonly bold?: boolean;
  readonly small?: boolean;
}

export const SmallText = styled(Typography)<SmallProps>`
  text-transform: ${(props) => (props.small ? "" : "uppercase")};
  font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #3d3d3d;
  font-size: ${(props) => (props.size ? "1.5rem" : "1.25rem")};
  line-height: ${(props) => (props.line ? "1.75rem" : "1.5rem")};
  font-weight: ${(props) => (props.bold ? "bold" : "normal")};
`;

interface Text3DProps {
  textTransform?: string;
  textColor?: string;
  textSize?: string;
  textHeight?: string;
  textWeight?: number;
}

export const Text3D = styled(Typography.Text)<Text3DProps>`
  &.ant-typography {
    text-transform: ${({ textTransform }) => textTransform || "inherit"};
    font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
    color: ${({ textColor }) => textColor || "#3D3D3D"};
    font-size: ${({ textSize }) => textSize || "1.25rem"};
    line-height: ${({ textHeight }) => textHeight || "24px"};
    font-weight: ${({ textWeight }) => textWeight || "normal"};
  }
`;
